import { useEffect, useState } from 'react'
import { Link } from '@inertiajs/inertia-react'
import axios from 'axios'
import RollerLoading from '../RollerLoading'
import { toast, ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import Order from './Order'




export function OrdersList({ orders, isSuperAdmin, withCheckboxes, selectedOrders, setSelectedOrders, invoiceRequested, setInvoiceRequested, emmitedOrders }) {
    
    const handleAllCheckboxChange = (event) => {
        if (event.target.checked) {
          const allOrderIds = orders.map((order) => order.id);
          setSelectedOrders(allOrderIds);
        } else {
          setSelectedOrders([]);
        }
      };
    if (!orders.length)
        return (
            <div className='text-xl text-center font-bold text-gray-600'>
                No hay órdenes creadas para este cupo.
            </div>
        );

        useEffect(() => {
            console.log(selectedOrders)
        }, [selectedOrders])

    return (
        <>
            <div className="px-6 py-4  bg-white shadow-md overflow-hidden sm:rounded-lg overflow-x-auto">
                <h2 className='mb-4 text-gray-900 text-lg font-bold'>Órdenes</h2>
                <table className='w-[1440px] text-left border-separate'>
                    <thead>
                        <tr>
                            {
                                withCheckboxes &&
                                <th>
                                    <input type="checkbox"
                                     checked={selectedOrders.length === orders.length}
                                     onChange={handleAllCheckboxChange}
                                    />
                                </th>
                            }
                            <th className='w-min'>Id</th>
                            <th className='w-auto'>Payment ID</th>
                            <th className="" >N° Boleta SII</th>
                            <th className=''>Nombre</th>
                            <th className=''>Apellido</th>
                            <th className=''>Creación</th>
                            <th className=''>Estado</th>
                            <th className=''>Ver</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            orders.map(o => {
                            // setInvoiceRequested(emmitedOrders.find(order => order === o.id))
                            return <Order 
                                isSuperAdmin={isSuperAdmin} 
                                order={o} 
                                key={o.uuid} 
                                withCheckboxes={withCheckboxes}
                                selectedOrders={selectedOrders}
                                setSelectedOrders={setSelectedOrders}
                                // invoiceRequested={invoiceRequested}
                                // setInvoiceRequested={setInvoiceRequested}
                                emmitedOrders={emmitedOrders}
                                />})
                        }
                    </tbody>
                </table>
            </div>
            <ToastContainer />
        </>
    );
}
